// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"1c37c765","418":"f6a9da30","515":"12a9a59d","828":"fe76edcc","937":"394b863c"}[chunkId] + ".chunk.css";
};